import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import {AppSettings} from '../../app-settings';
import {HttpClientService} from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import {SessionService} from '../../Services/session.service';
import {Subscription} from 'rxjs';
import { EventService } from "../../Services/event.service";

@Component({
  selector: 'app-bookmarks',
  templateUrl: './bookmarks.component.html',
  styleUrls: ['./bookmarks.component.css']
})
export class BookmarksComponent implements OnInit, OnDestroy {

  constructor(private httpClientService: HttpClientService , private sanitizer: DomSanitizer, private sessionService: SessionService, private eventService: EventService)
  { }

  bookmarksDummy  = [];

  options:any = [{"displayName":"Verbal Section", "type":"VERBAL","id":"VerbalSection","verbalFirstList":false,
                                  "optionsSecondary":[]},

                                  {"displayName":"Quant Section", "type":"QUANT","id":"QuantSection",
                                  "optionsSecondary":[]},
                                  {"displayName":"DI Section", "type":"DI","id":"DISection",
                                  "optionsSecondary":[]}];

  selectModeOn:boolean  =false;
  public filterQuery = "";
  public sortBy = "createdTime";
  public sortOrder = "desc";
  isDateSortedByMeDesc:boolean=true;
  isNameSortedByMeDesc:boolean=true;
  nameSorted:boolean=false;
  dateSorted:boolean=true;
  deleteImage = AppSettings.cdnUrl +"assets/images/delete-btn.png";
  deleteImageRed  = AppSettings.cdnUrl+"assets/images/delete_red_btn.png";
  loadingCircleURL = AppSettings.loadingCircleImageURL;
  dataLoaded:boolean = true;
  activeOptions = [];
  statusFilterBy:string = "subject";
  tableRowHover:boolean = false;
  bookmarkData = [];
  bookmarkDataAll = [];
  bookmarkDataObject:any = {};
  questionCharacterCount:number = 144;
  questionHeadingCount:number = 40;
  serverErrorFlag:boolean = false;
  userInfoSubscription:Subscription;
  userEmail:string;
  sectionIndexes = {
    OG_VERBAL: 0,
    VERBAL: 0,
    OG_QUANT: 1,
    QUANT: 1,
    'DATA INSIGHTS': 2,
    DATA_INSIGHTS: 2,
    DI: 2,
    OG_DI: 2
}

  ngOnInit() {

      this.getBookmarksData();
      this.getFullName();
  }

  getFullName()
  {

    this.userInfoSubscription = this.sessionService.getUserInfo$.
    subscribe(data => { if(data != "")
     this.userEmail = data.username;
     if(this.userEmail)
     {
       this.fireAccessedEvent();
     }
      });

   }

  fireAccessedEvent()
  {
    this.eventService.track('Accessed_User_Info', {"Accessed_Reason":"bookmarks"}, this.userEmail);
  }

   getBookmarksData()
  {
      let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl+'/api/user/quiz/bookmarks/'
          , headers)
      .subscribe(
      (data) => {
                  this.bookmarkData = [];
                  if(data.bookmarkList != null)
                  {
                  this.bookmarksDummy = data.bookmarkList;
                  var bookamrakDataLength = this.bookmarksDummy.length;
                  for(var i=0; i<bookamrakDataLength;i++)
                  {
                      this.bookmarkDataObject = {};
                      this.bookmarkDataObject.id = this.bookmarksDummy[i].bookmarkId;
                      if(this.bookmarksDummy[i].questionText != null)
                      {
                        this.bookmarkDataObject.questionText = this.sanitizer.bypassSecurityTrustHtml(this.bookmarksDummy[i].questionText.replace(/<\s*(\w+).*?>/, '<$1>').
                                                               replace(/&nbsp;/gi,''));
                        this.bookmarkDataObject.questionTextTable = this.sanitizer.bypassSecurityTrustHtml(this.bookmarksDummy[i].questionText.replace(/<\s*([a-z][a-z0-9]*)\s.*?>/gi, '<$1>').
                                                             replace(/&nbsp;/gi,'').replace(/<img[^>]*>/g,"").replace("<style(.+?)</style>", ""));
                      }
                      else
                      {
                        this.bookmarkDataObject.questionText = this.sanitizer.bypassSecurityTrustHtml('NA');
                        this.bookmarkDataObject.questionTextTable = this.sanitizer.bypassSecurityTrustHtml('NA');
                      }
                      this.bookmarkDataObject.quizName = this.bookmarksDummy[i].quizName;
                      this.bookmarkDataObject.createdTime = this.bookmarksDummy[i].createdTime;
                      this.bookmarkDataObject.url = this.bookmarksDummy[i].url;
                      this.bookmarkDataObject.hoverOver = false;
                      this.bookmarkDataObject.subject = this.bookmarksDummy[i].subject;
                      let index = this.sectionIndexes[this.bookmarksDummy[i].section];
                      let indexSecondaryOption = this.options[index].optionsSecondary.findIndex((option)=>{return option.displayName == this.bookmarksDummy[i].subject;});
                      if(indexSecondaryOption==-1)
                      {
                        let option = {
                          "displayName":this.bookmarksDummy[i].subject,
                          "type":this.bookmarksDummy[i].subject,
                          "id":this.getSubjectsShortCode(this.bookmarksDummy[i].subject)
                        };
                        this.options[index].optionsSecondary.push(option);
                      }
                      this.bookmarkDataObject.quizApplication = this.bookmarksDummy[i].quizApplication;
                      this.bookmarkData.push(this.bookmarkDataObject);
                  }
                  this.bookmarkDataAll = this.bookmarkData;
                  }
                  this.dataLoaded = false;
      },(e)=>{

          if(e.status == 500)
          {
            this.serverErrorFlag = true;
          }
          this.dataLoaded = false;
      });
    }
  getSubjectsShortCode(subject)
  {
    if(subject.indexOf(' ')>-1)
    {
      return subject.split(' ')[0].charAt(0) + subject.split(' ')[1].charAt(0);
    }
    else
    {
      return subject;
    }

  }
  toggleSelect()
  {
    this.selectModeOn = !this.selectModeOn;
  }
  posBlock(event)
  {
    var popUp = event.target.querySelectorAll(".pop_block")[0];
    var popUpHeight = popUp.offsetHeight;
    var tableRowHeight = event.target.parentElement.offsetHeight;
    popUp.style.top = ((tableRowHeight - popUpHeight)/2)+"px";
  }

  deleteBookmark(bookmarkId,quizApplication)
  {
    //this.bookmarkDataAll.splice(index,1);
    var url = '';
    if(quizApplication == "SCHOLARANIUM")
    {
      url = '/api/user/quiz/scholaranium/bookmark/delete/'+bookmarkId+'/';
    }
    else if (quizApplication == "MIQA")
    {
      url = '/api/user/quiz/miqa/boomark/delete/'+bookmarkId+'/';
    }
    let headers = new HttpHeaders();
    this.httpClientService.post(AppSettings.restApiUrl +
          url,null, headers)
      .subscribe(
      (data) => {

          this.getBookmarksData();
      }
      );
  }
  updateCheckedOptions(option, $event)
  {
      if ($event.target.checked)
      {
        this.activeOptions.indexOf(option.type)>=0?'':this.activeOptions.push(option.type);
      }
      else
      {
        this.activeOptions.splice(this.activeOptions.indexOf(option.type), 1);
      }
  }
  updateCheckState(element:any, event)
  {
      var allBoxes = element.optionsSecondary;
      if(event.target.checked)
      {
        for(var i =0; i<allBoxes.length;i++)
        {
          (<HTMLInputElement>document.getElementById(allBoxes[i].id)).checked = true;
          this.activeOptions.indexOf(allBoxes[i].type)>=0?'':this.activeOptions.push(allBoxes[i].type);
        }
      }
      else
      {
        for(var i =0; i<allBoxes.length;i++)
        {
            (<HTMLInputElement>document.getElementById(allBoxes[i].id)).checked = false;
            if(this.activeOptions.indexOf(allBoxes[i].type)>-1)
            {
              this.activeOptions.splice(this.activeOptions.indexOf(allBoxes[i].type), 1);
            }
        }
      }
  }
  sortColumn(colName)
  {
    if(colName=='name')
    {
      this.dateSorted=false;
      if(!this.nameSorted)
      {
          this.isNameSortedByMeDesc = false;
          this.nameSorted = true;
      }
      else
      {
        this.isNameSortedByMeDesc = !this.isNameSortedByMeDesc;
      }
    }
    if(colName=='date')
    {
      this.nameSorted=false;
      if(!this.dateSorted)
      {
          this.isDateSortedByMeDesc = false;
          this.dateSorted = true;
      }
      else
      {
        this.isDateSortedByMeDesc = !this.isDateSortedByMeDesc;
      }
    }
  }
  @HostListener('unloaded')
  ngOnDestroy(): void {
    this.userInfoSubscription.unsubscribe();
  }
}
